var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/expand-more"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2992 9.32461C17.4826 9.50794 17.5742 9.74128 17.5742 10.0246C17.5742 10.3079 17.4826 10.5413 17.2992 10.7246L12.6992 15.3246C12.5992 15.4246 12.4909 15.4954 12.3742 15.5371C12.2576 15.5788 12.1326 15.5996 11.9992 15.5996C11.8659 15.5996 11.7409 15.5788 11.6242 15.5371C11.5076 15.4954 11.3992 15.4246 11.2992 15.3246L6.67422 10.6996C6.49089 10.5163 6.39922 10.2913 6.39922 10.0246C6.39922 9.75794 6.49922 9.52461 6.69922 9.32461C6.88255 9.14128 7.11589 9.04961 7.39922 9.04961C7.68255 9.04961 7.91589 9.14128 8.09922 9.32461L11.9992 13.2246L15.9242 9.29961C16.1076 9.11628 16.3326 9.02461 16.5992 9.02461C16.8659 9.02461 17.0992 9.12461 17.2992 9.32461Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand-more.b896666641a8eadf52ce912a29cd9831.svg";
export { ForwardRef as ReactComponent };